// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralState } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/State/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useCollateralState: () => UseQueryResult<
  TemplateContract<CollateralState>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOffset({
    queryKey: ['queryCollateralState', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      return ledgerApi.queryCollateralState(offset, operator);
    },
  });
};

export default useCollateralState;
